import { render, staticRenderFns } from "./stock_detail.vue?vue&type=template&id=d5b8028a&scoped=true&lang=pug&"
import script from "./stock_detail.vue?vue&type=script&lang=js&"
export * from "./stock_detail.vue?vue&type=script&lang=js&"
import style0 from "./stock_detail.vue?vue&type=style&index=0&id=d5b8028a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b8028a",
  null
  
)

export default component.exports